import React from "react";
import "./HowItWorks.css";

const STEPS = [
  {
    id: "step-1",
    stepNumber: "01.",
    title: "WATCH",
    desktopText:
      "Your child opens the quest map and picks which character or story they want to watch, all at their own pace.",
    mobileText: "Your child opens the quest map and picks which character or story they want to watch, all at their own pace.",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev3/Watch.png",
    color: "#06235C",
  },
  {
    id: "step-2",
    stepNumber: "02.",
    title: "SOLVE",
    desktopText:
      "After each story, a fun quiz checks what they remember. They can try again as many times as they like.",
    mobileText: "After each story, a fun quiz checks what they remember. They can try again as many times as they like.",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev3/Watch (1).png",
    color: "#4BB523",
  },
  {
    id: "step-3",
    stepNumber: "03.",
    title: "EARN",
    desktopText: "Kids unlock digital trophies as they progress, building lasting confidence and curiosity to learn more.",
    mobileText: "Kids unlock digital trophies as they progress, building lasting confidence and curiosity to learn more.",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev3/Watch (2).png",
    color: "#F27813",
  },
];

export const HowItWorks = () => {
  return (
    <section className="how-it-works">
      {/* Title */}
      <div className="how-it-works__header">
        <span className="sparkle-left"></span>
        <h2>
          <img
            className="howitwrkicn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
            alt=""
          />
          How Yuva Quest Works
          <img
            className="howitwrkrgticn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
            alt=""
          />
        </h2>
        <span className="sparkle-right"></span>
        <div className="header-underline"></div>
      </div>

      {/* Grid Container */}
      <div className="how-it-works__grid">
        {STEPS.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`how-it-works__card step-${index + 1}`}>
              <div className="card-image-wrapper">
                <img src={step.image} alt={step.title} />
              </div>

              <div className="card-content text-center">
                <div className="card-heading">
                  <span
                    className="step-badge"
                    style={{ backgroundColor: step.color }}
                  >
                    {step.stepNumber}
                  </span>
                  <h3 style={{ color: step.color }}>{step.title}</h3>
                </div>
                <p className="desktop-text">{step.desktopText}</p>
                <p className="mobile-text">{step.mobileText}</p>
              </div>
            </div>

            {/* Connecting curve SVGs for Mobile */}
            {index === 0 && (
              <div className="curve-connector curve-1">
                <img
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/Vector+7.svg"
                  alt=""
                />
              </div>
            )}
            {index === 1 && (
              <div className="curve-connector curve-2">
                <img
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/Vector 8.svg"
                  alt=""
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};
